import { render, staticRenderFns } from "./UploadPhoneFile.vue?vue&type=template&id=4519469e&scoped=true&"
import script from "./UploadPhoneFile.vue?vue&type=script&lang=js&"
export * from "./UploadPhoneFile.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./UploadPhoneFile.vue?vue&type=style&index=0&id=4519469e&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4519469e",
  null
  ,true
)

export default component.exports